import $ from "jquery";
import Splide from "@splidejs/splide";

$(function () {
	let photo_tab_content_scroller = document.querySelectorAll(".photo-tab-content-scroller");
	if (photo_tab_content_scroller.length > 0) {
		for (let i = 0; i < photo_tab_content_scroller.length; i++) {
			let photo_tab_content_scrollerElement = photo_tab_content_scroller[i];
			let photo_tab_content_scrollerDefaultOptions = {
				type: "loop",
				arrows: true,
				pagination: false,
				trimSpace: false,
				perPage: 2.5,
				perMove: 1,
				gap: "30px",
				breakpoints: {
					1024: {
						perPage: 2,
					},
					767: {
						perPage: 2,
					},
					640: {
						perPage: 1,
						padding: "4rem",
					},
				},
			};
			let carousel = new Splide(photo_tab_content_scrollerElement, photo_tab_content_scrollerDefaultOptions);
			carousel.mount();
		}
	}

	let video_tab_content_scroller = document.querySelectorAll(".video-tab-content-scroller");
	if (video_tab_content_scroller.length > 0) {
		for (let i = 0; i < video_tab_content_scroller.length; i++) {
			let video_tab_content_scrollerElement = video_tab_content_scroller[i];
			let video_tab_content_scrollerDefaultOptions = {
				type: "loop",
				arrows: true,
				pagination: false,
				trimSpace: false,
				perPage: 2.5,
				perMove: 1,
				gap: "30px",
				breakpoints: {
					1024: {
						perPage: 2,
					},
					767: {
						perPage: 2,
					},
					640: {
						perPage: 1,
						padding: "4rem",
					},
				},
			};
			let carousel = new Splide(video_tab_content_scrollerElement, video_tab_content_scrollerDefaultOptions);
			carousel.mount();
		}
	}
});
